import { linkHorizontal as d3LinkHorizontal, linkVertical as d3LinkVertical } from 'd3-shape';

import { isHorizontal, transformToOrientation } from '@Components/D3Tree/utils';
import { NODE_TYPE_SUBSTANCE, NODE_TYPE_LINK } from '../constants';
import { SUBSTANCE_WIDTH, SUBSTANCE_HEIGHT } from '../components/SubstanceNode';
import {
  LINK_NODE_HORIZONTAL_WIDTH,
  LINK_NODE_VERTICAL_HEIGHT,
  LINK_NODE_MULTISTEP_SIZE,
  LINK_NODE_CONNECTION_OFFSET,
} from '../components/LinkNode';

function offsetHorizontal(node) {
  const { data = {} } = node;

  switch (data._type) {
    case NODE_TYPE_SUBSTANCE: {
      return SUBSTANCE_WIDTH / 2;
    }
    case NODE_TYPE_LINK: {
      if (data?._data?.multiStep) {
        return LINK_NODE_MULTISTEP_SIZE / 2;
      }
      return LINK_NODE_HORIZONTAL_WIDTH / 2 + LINK_NODE_CONNECTION_OFFSET;
    }
    default: {
      return 0;
    }
  }
}

function offsetVertical(node) {
  const { data = {} } = node;

  switch (data._type) {
    case NODE_TYPE_SUBSTANCE: {
      return SUBSTANCE_HEIGHT / 2;
    }
    case NODE_TYPE_LINK: {
      if (data?._data?.multiStep) {
        return LINK_NODE_MULTISTEP_SIZE / 2;
      }
      return LINK_NODE_VERTICAL_HEIGHT / 2;
    }
    default: {
      return 0;
    }
  }
}

// Adjust source and target nodes connection points
function drawDiagonalPath({ source, target }, { orientation }) {
  let sourceOffset;
  let targetOffset;
  let func;

  if (isHorizontal(orientation)) {
    sourceOffset = offsetHorizontal(source);
    targetOffset = offsetHorizontal(target);
    func = d3LinkHorizontal();
  } else {
    sourceOffset = offsetVertical(source);
    targetOffset = offsetVertical(target);
    func = d3LinkVertical();
  }

  const tSource = transformToOrientation(
    {
      x: source.x,
      y: source.y + sourceOffset,
    },
    orientation
  );
  const tTarget = transformToOrientation(
    {
      x: target.x,
      y: target.y - targetOffset,
    },
    orientation
  );

  return func({
    source: [tSource.x, tSource.y],
    target: [tTarget.x, tTarget.y],
  });
}

export default drawDiagonalPath;
